// extracted by mini-css-extract-plugin
export var assigneeBadge = "_j5-0";
export var assigneeDetails = "_j5-1";
export var assigneeInfo = "_j5-2";
export var dropdownContainer = "_j5-4";
export var dropdownImage = "_j5-5";
export var editAssigneeInfo = "_j5-3";
export var editAssigneeModalContainer = "_j5-6";
export var hidden = "_j5-8";
export var input = "_j5-7";